import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TestAccountsIcon = ({
  title
}) => {
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": "vertical-nav-icon__test-accounts",
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, /*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_114_251)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M15.8462 14.4613C15.9432 14.2661 16 14.0357 16 13.7929C16 13.4383 15.8795 13.1115 15.6769 12.852L15.6794 12.8557L11.0831 7.29563V2.35335H11.3919C11.9035 2.35335 12.3186 1.9382 12.3186 1.42668C12.3186 0.915151 11.9035 0.5 11.3919 0.5H4.59632C4.08479 0.5 3.66964 0.915151 3.66964 1.42668C3.66964 1.9382 4.08479 2.35335 4.59632 2.35335H4.90521V7.29563L0.308892 12.8557C0.116143 13.1108 0 13.4327 0 13.7824C0 14.6355 0.691301 15.3268 1.54446 15.3268H14.463C15.0678 15.3268 15.5904 14.9784 15.8418 14.4706L15.8456 14.4613H15.8462ZM8.61192 12.8551C8.61192 12.5141 8.88868 12.2373 9.2297 12.2373H12.3186C12.6596 12.2373 12.9364 12.5141 12.9364 12.8551C12.9364 13.1961 12.6596 13.4729 12.3186 13.4729H9.2297C8.88868 13.4729 8.61192 13.1961 8.61192 12.8551ZM6.54852 8.1908C6.67949 8.03203 6.75918 7.82692 6.75918 7.60267L6.75856 7.57178V7.57301V2.35274H9.2297V7.6039L9.22908 7.63356C9.22908 7.85781 9.30878 8.06292 9.44098 8.22292L9.43975 8.22107L11.2499 10.3833H4.73841L6.54852 8.1908Z",
        fill: "#DFE3EB"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_114_251",
        children: /*#__PURE__*/_jsx("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      })
    })]
  });
};
export default TestAccountsIcon;